<h2 i18n="@@DialogWrongLanguageCaption">
  <mat-icon style="vertical-align: middle">error</mat-icon>&nbsp;Attenzione</h2>
<p i18n="@@DialogWrongLanguageInputDialogText">
  La lingua richiesta non è disponibile, il certificato è stato inviato nella lingua di default. Per ulteriori informazioni
  contattare il servizio clienti.
</p>
<div style="margin-top: 10px; text-align: right">
  <button mat-raised-button (click)="closeDialog()" i18n="@@CloseDialog">Chiudi</button>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/wrong-language-dialog/wrong-language-dialog.html